// extracted by mini-css-extract-plugin
module.exports = {"bgRed":"DangerNotice_bgRed__0_Kf0"};